import { render, staticRenderFns } from "./IconMore.vue?vue&type=template&id=24492abb&"
import script from "./IconMore.vue?vue&type=script&lang=ts&"
export * from "./IconMore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports